import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { LookupPeriodoCursada } from '../PeriodoCursada/LookupPeriodoCursada';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatPeriodoDictadoLabel(dictado) {
  if (dictado === '1') return 'Primer Cuatrimestre';
  if (dictado === '2') return 'Segundo Cuatrimestre';
  return 'Anual';
}

export class UpdateCursada extends Component {
  static displayName = UpdateCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      errorMessage: '',
      redirect: false,
      carrera: { carreraCodigo: '', carreraNombre: '', dictado: '' },
      periodoCursada: { codigo: 0, descripcion: '', dictado: '' },
      showLookupMaterias: false,
      showLookupPeriodoCursada: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('WWCursada')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleSelectMateriaItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupMaterias: false,
      carrera: {
        carreraCodigo: carreraProperties[0],
        carreraNombre: carreraProperties[1] + '-' + carreraProperties[2],
        dictado: carreraProperties[4].trim(),
      },
    });
  };

  handleSelectPeriodoCursadaItem = (e) => {
    const periodoProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupPeriodoCursada: false,
      periodoCursada: {
        codigo: periodoProperties[0],
        descripcion: periodoProperties[1] + '-' + periodoProperties[2],
        dictado: periodoProperties[3].trim(),
      },
    });
  };

  handleShowMateriaLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleHideMateriaLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleShowPeriodoCursadaLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupPeriodoCursada: true });
    }
  };

  handleHidePeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  isFormValid() {
    return (
      this.state.carrera.carreraNombre.length > 0
      && this.state.periodoCursada.descripcion.length > 0
    );
  }

  isDictadoValid() {
    return this.state.carrera.dictado === this.state.periodoCursada.dictado;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }

    if (!this.isDictadoValid()) {
      this.setState({
        errorMessage: 'La materia seleccionada no se dicta en el período seleccionado.',
      });
      return;
    }

    this.saveCursada();
  }

  getPeriodoCursada(periodoCursadaDescripcion) {
    return formatPeriodoDictadoLabel(periodoCursadaDescripcion);
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/cur/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(data, 'No se pudieron cargar los datos de la cursada.'),
      });
      return;
    }

    const model = data.returnModel;
    this.setState({
      loadingInitial: false,
      carrera: {
        carreraNombre: (model.materiaCarreraCodigo || '').trim() + '-' + model.materiaNombre,
        carreraCodigo: model.materiaCarreraCod,
        dictado: model.materiaDictado,
      },
      periodoCursada: {
        codigo: model.periodoCursadaCod,
        descripcion: this.getPeriodoCursada(model.periodoCursadaDescripcion) + '-' + model.anioAcademicoDescripcion,
        dictado: model.periodoCursadaDescripcion,
      },
    });
  }

  async saveCursada() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/cur', {
      method: 'POST',
      body: JSON.stringify({
        CursadaCod: parseInt(this.state.id, 10),
        PeriodoCursadaCod: parseInt(this.state.periodoCursada.codigo, 10),
        MateriaCarreraCod: this.state.carrera.carreraCodigo.trim(),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la cursada. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-cur" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      carrera,
      periodoCursada,
      showLookupMaterias,
      showLookupPeriodoCursada,
      errorMessage,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly ? 'Ver datos de Cursada' : 'Modificar Cursada';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-cur">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-cur">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-cur">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la cursada.'
            : 'Actualice la materia o el período de cursada y confirme los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando cursada, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowMateriaLookup}
                  disabled={isBusy}
                >
                  Seleccione la Materia
                </button>
              ) : null}
              {showLookupMaterias ? (
                <LookupMaterias
                  selectItem={this.handleSelectMateriaItem}
                  hideLookup={this.handleHideMateriaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={carrera.carreraNombre}
                disabled
                readOnly
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Cursada</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowPeriodoCursadaLookup}
                  disabled={isBusy}
                >
                  Seleccione el Período de Cursada
                </button>
              ) : null}
              {showLookupPeriodoCursada ? (
                <LookupPeriodoCursada
                  selectItem={this.handleSelectPeriodoCursadaItem}
                  hideLookup={this.handleHidePeriodoCursadaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={periodoCursada.descripcion}
                disabled
                readOnly
                aria-label="Período de cursada"
              />
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
